import {EnvVarsValues} from './envVarsValues';

function getDotEnvValues() {
  // Yeah, this is definitely not pretty—but it's the way the bundler
  // understands that a env variable should be injected into the code.
  //
  // We have to explicitly declare it, like `process.env.LD_CLIENT_SIDE_ID`,
  // which will get fully replaced with a string at build time.
  //
  // If we do something like `process.env[var]`, it won’t work,
  // since the bundler has no way to know what `var` contains.
  const values: EnvVarsValues = {
    LD_CLIENT_SIDE_ID: process.env.LD_CLIENT_SIDE_ID || '',
    SHIPWELL_API_BASE_PATH: process.env.SHIPWELL_API_BASE_PATH || '',
    SHIPWELL_PRICING_API_BASE_PATH: process.env.SHIPWELL_PRICING_API_BASE_PATH || '',
    SHIPWELL_DIGITAL_DOCUMENTS_API_BASE_PATH: process.env.SHIPWELL_DIGITAL_DOCUMENTS_API_BASE_PATH || '',
    SHIPWELL_CORROGO_API_BASE_PATH: process.env.SHIPWELL_CORROGO_API_BASE_PATH || '',
    SHIPWELL_SHIPMENT_ASSEMBLY_API_BASE_PATH: process.env.SHIPWELL_SHIPMENT_ASSEMBLY_API_BASE_PATH || '',
    SHIPWELL_GENESIS_API_BASE_PATH: process.env.SHIPWELL_GENESIS_API_BASE_PATH || '',
    SHIPWELL_SCRIPTLAB_API_BASE_PATH: process.env.SHIPWELL_SCRIPTLAB_API_BASE_PATH || '',
    SHIPWELL_LOCUS_API_BASE_PATH: process.env.SHIPWELL_LOCUS_API_BASE_PATH || '',
    SHIPWELL_ERP_GATEWAY_API_BASE_PATH: process.env.SHIPWELL_ERP_GATEWAY_API_BASE_PATH || '',
    SHIPWELL_AUTH_MICROSSERVICE_API_BASE_PATH: process.env.SHIPWELL_AUTH_MICROSSERVICE_API_BASE_PATH || '',
    AUTH0_DOMAIN: process.env.AUTH0_DOMAIN || '',
    AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID || '',
    AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE || '',
    REACT_QUERY_DEVTOOLS: process.env.REACT_QUERY_DEVTOOLS || '',
    USE_SHORT_TIME_OPTIONS: process.env.USE_SHORT_TIME_OPTIONS || '',
    SHIPWELL_SPOT_QUOTE_VENDOR_ID: process.env.SHIPWELL_SPOT_QUOTE_VENDOR_ID || '',
    INTERCOM_APP_ID: process.env.INTERCOM_APP_ID || '',
    CLIENT_ID_AMAZON_FREIGHT: process.env.CLIENT_ID_AMAZON_FREIGHT || '',
    AMAZON_FREIGHT_URL: process.env.AMAZON_FREIGHT_URL || '',
    AMAZON_ENV: process.env.AMAZON_ENV || '',
    SHIPWELL_TEMPUS_API_BASE_PATH: process.env.SHIPWELL_TEMPUS_API_BASE_PATH || '',
    SHIPWELL_SETTLEMENTS_API_BASE_PATH: process.env.SHIPWELL_SETTLEMENTS_API_BASE_PATH || '',
    SHIPWELL_SWIFTY_BASE_PATH: process.env.SHIPWELL_SWIFTY_BASE_PATH || '',
    ROLLBAR_ENV: process.env.ROLLBAR_ENV || '',
    ROLLBAR_POST_CLIENT_ITEM_ACCESS_TOKEN: process.env.ROLLBAR_POST_CLIENT_ITEM_ACCESS_TOKEN || '',
    VERSION: process.env.VERSION || '',
    SWIFTY_BASE_URL: process.env.SWIFTY_BASE_URL || '',
    TEMPORARY_TESTING_JWT: process.env.TEMPORARY_TESTING_JWT || '',
    SHIPWELL_DOCUMENT_STORE_API_BASE_PATH: process.env.SHIPWELL_DOCUMENT_STORE_API_BASE_PATH || '',
    SHIPWELL_AI_STUDIO_CHANNEL_API_BASE_PATH: process.env.SHIPWELL_AI_STUDIO_CHANNEL_API_BASE_PATH || '',
    SHIPWELL_AI_STUDIO_AGENT_API_BASE_PATH: process.env.SHIPWELL_AI_STUDIO_AGENT_API_BASE_PATH || '',
    STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY || '',

    // System
    NODE_ENV: process.env.NODE_ENV || 'development'
  };

  return values;
}

export function parseValuesWithFallbacks(baseValues?: Partial<EnvVarsValues>) {
  const dotEnvValues = getDotEnvValues();
  const finalValues = {...dotEnvValues};

  (Object.keys(finalValues) as Array<keyof EnvVarsValues>).forEach((key) => {
    finalValues[key] = baseValues?.[key] || finalValues[key];
  });

  return finalValues;
}
